<template>
  <div class="hero-image-wrapper">
    <slot name="images" />
  </div>
</template>

<script>
export default {
  name: 'hero-image',
}
</script>

<style lang="scss" scoped>
.hero-image-wrapper {
  background-image: url(~@images/vote/bg_vote-confirm.png);
  background-repeat: no-repeat;
  background-position: center;
  font-size: $fs-large;
  margin: 0 auto 20px;
  width: 486px;
  height: 472px;
  position: relative;
  > * {
    position: absolute;
    top: 0;
    left: 0; 
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
